import React from 'react';
import { ProgressBar, Card, Row, Col, Button, Form, Toast, Tabs, Tab, Alert, Table, OverlayTrigger, Tooltip, Badge } from 'react-bootstrap';
import DateChoice from '../dateChoice/DateChoice';
import CommentList from '../comment/CommentList';
import DateChoiceResponseInfo from '../dateChoice/DateChoiceResponseInfo';
import { translate } from "react-i18next";
import './EventAddTabs.css';
import { sendJson, getURL, EVENT_IMG_URL, GOOGLEMAP_URL, EDIT_URL } from '../../backend/Backend';
import { Link } from 'react-router-dom';
import AuthenticationService from '../../backend/AuthenticationService';
import { GREEN_LIGHT, RED_LIGHT,  GREEN,  LIGHT_BORDER } from "../../backend/Colors";
import { getLocationDisplay } from '../../backend/UIUtils';
import i18n from "i18next";
import { getCountries } from '../../backend/Countries';
import EventNotify from '../user/EventNotify';
import Sharing from "../util/Sharing"





class EventEditPages extends React.Component {
  constructor(props) {
    super(props);
    this.saveEvent = this.saveEvent.bind(this);
    this.sendDecline = this.sendDecline.bind(this);
    this.onRadioInputChange = this.onRadioInputChange.bind(this);
    this.onInvitedUserChange = this.onInvitedUserChange.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.loadDateChoiceResponses = this.loadDateChoiceResponses.bind(this);

    this.loadAllInviteds = this.loadAllInviteds.bind(this);
    this.pageChanged = this.pageChanged.bind(this);
    this.ultimateChange = this.ultimateChange.bind(this);
    this.updateStatus = this.updateStatus.bind(this);
    this.addFavorite = this.addFavorite.bind(this);
    this.notifyEvent = this.notifyEvent.bind(this);
    this.addSubscription = this.addSubscription.bind(this);


    this.state = {
      event: {
        "userId": '', "username": '', "userCommentsEnabled": false,
        "description": '', "eventLink": '', "title": '', "locationName": null, "street": '',
        "zipcode": '', "city": '', "country": '', "invitedUser": {}, "choiceResponseModels": [],
        "invitedUsers": [], "newUserName": '', "newUserEmail": '', "eventStatus": '',
        "allDateChoiceResponses": [],
        "dateChoices": [],
        "status": {}
      }
      , user: null
      , favorite: false
      , message: ''
      , forwardUrl: ''
      , inviteds: []
      , activePage: 1
      , totalPages: 0,
      favMessage: '',
      aboMessage: '',
      activeTab: "comments" 
    }
  }

  async componentDidMount() {
    let user = null;
    if (AuthenticationService.isUserLoggedIn()) {
      user = AuthenticationService.getLoggedUser();
    }

    const response = await fetch(getURL(`events/load/` + this.props.id + `/${user && user.id ? user.id : 0}`));
    const json = await response.json();
    console.log("Event load:" + JSON.stringify(json))
    let newEvent = json;
    if (newEvent.invitedUser && (newEvent.invitedUser.name || newEvent.invitedUser.email)) {
      newEvent.newUserName = newEvent.invitedUser.name;
      newEvent.newUserEmail = newEvent.invitedUser.email;
    } else {
      let user = null;
      if (AuthenticationService.isUserLoggedIn()) {
        user = AuthenticationService.getLoggedUser();
        if (user != null) {
          newEvent.newUserName = user.name;
          newEvent.newUserEmail = user.email;
        }
      }
    }

    let oldState = this.state;

    this.setState({
      ...oldState,
      event: newEvent,
      favorite: json.favorite
      //user: user 
    });
  }

  async ultimateChange(termin) {
    let ultimate = termin.ultimate;
    let id = termin.dateChoiceId;
    const response = await fetch(getURL(`dateChoices/ultimate/${id}/${ultimate ? 0 : 1}`));
    const json = await response.json();
    if (json.ok) {
      let choiceResponseModels = this.state.event.choiceResponseModels;
      let choice = choiceResponseModels.find(e => e.dateChoiceId === id);
      const index = choiceResponseModels.findIndex(i => i.dateChoiceId === id);
      choice.ultimate = ultimate ? 0 : 1;
      let newModels = [...choiceResponseModels.slice(0, index),
        choice,
      ...choiceResponseModels.slice(index + 1)];

      let oldEvent = this.state.event;
      let newEvent = {
        ...oldEvent,
        choiceResponseModels: newModels
      }
      this.setState({ event: newEvent });
    }

  }

  async updateStatus(id, status) {
    //let id = this.props.id;
    const response = await fetch(getURL(`events/updateStatus/${id}/${status}`));
    const json = await response.json();
    if (json.ok) {
      let oldState = this.state;
      let oldEvent = this.state.event;
      let newEvent = {
        ...oldEvent,
        eventStatus: status
      }
      this.setState({
        ...oldState,
        message: json.message,
        event: newEvent
      });
    }
  }



  saveEvent() {
    const { event } = this.state;
    let newModel = {
      "invitedUser": this.state.event.invitedUser,
      "newUserName": this.state.event.newUserName,
      "newUserEmail": this.state.event.newUserEmail,
      "choiceResponseModels": this.state.event.choiceResponseModels
    };

    this.doSave(newModel);

  }


  sendDecline() {
    this.state.event.choiceResponseModels.map(termin =>
      termin.responseType = 'NO'
    );
    let newModel = {
      "invitedUser": this.state.event.invitedUser,
      "newUserName": this.state.event.newUserName,
      "newUserEmail": this.state.event.newUserEmail,
      "choiceResponseModels": this.state.event.choiceResponseModels
    };
    this.doSave(newModel);
  }

  doSave(newModel) {
    sendJson('post', 'dateChoiceResponses/save', newModel).then(
      received => {
        if (received.ok) {
          window.location.replace('#eventEdit/' + received.id);
          window.location.reload();
        }

      });
  }


  onInputChange(obj) {
    const { name: fieldName, value: fieldValue } = obj.target;
    let oldEvent = this.state.event;

    const newEvent = {
      ...oldEvent,
      [fieldName]: fieldValue
    };

    this.setState({
      event: newEvent
    });
  }

  async loadAllInviteds(page) {
    if (!page) {
      return;
    }
    if ("<" === page) {
      page = --this.state.activePage;
    }
    if (">" === page) {
      page = ++this.state.activePage;
    }
    const response = await fetch(getURL(`eventInvitedUsers/loadAllInviteds/${this.props.id}/${page - 1}`));
    const json = await response.json();
    let oldState = this.state;
    this.setState({
      ...oldState,
      inviteds: json.content,
      totalPages: json.totalPages,
      activePage: page
    });
  }

  async pageChanged(e) {
    this.loadAllInviteds(e.target.text);
  }


  async loadDateChoiceResponses() {
    const response = await fetch(getURL(`loadDateChoiceResponses/` + this.props.id));
    const json = await response.json();
    let oldEvent = this.state.event;
    let newEvent = {
      ...oldEvent,
      allDateChoiceResponses: json
    }
    this.setState({ event: newEvent });
  }

  async addFavorite() {
    let user = AuthenticationService.getLoggedUser();
    if (user && user.id) {
      let oldState = this.state;
      let fav = this.state.favorite;
      const response = fav ?
        await fetch(getURL(`events/removeFav/${this.state.event.eventId}/${user.id}`)) :
        await fetch(getURL(`events/addFav/${this.state.event.eventId}/${user.id}`));
      const json = await response.json();
      if (json.ok) {
        this.setState({
          ...oldState,
          favorite: !fav,
          favMessage: !fav ? 'favoriteAdded' : 'favoriteDeleted'
        });
        setTimeout(() => this.setState({ favMessage: '' }), 1000);
      }
    }

  }

  async addSubscription() {
    let user = AuthenticationService.getLoggedUser();
    if (user && user.id) {
      let oldState = this.state;
      let subs = this.state.event.subscription;
      const response = subs ?
        await fetch(getURL(`subscription/remove/${this.state.event.creationUserId}/${user.id}`)) :
        await fetch(getURL(`subscription/add/${this.state.event.creationUserId}/${user.id}`));
      const json = await response.json();
      if (json.ok) {
        let oldEvent = this.state.event;
        oldEvent.subscription = !subs;
        this.setState({
          ...oldState,
          event: oldEvent,
          aboMessage: !subs ? 'subscripeAdded' : 'subscripeDeleted'
        });
        setTimeout(() => this.setState({ aboMessage: '' }), 1000);
      }
    }

  }

  notifyEvent(comment) {
    let user = AuthenticationService.getLoggedUser();
    if (user && user.id) {
      let item = { 'comment': comment, 'eventId': this.state.event.eventId, 'userId': user.id };

      sendJson('post', 'notify', item).then(
        received => {
          if (received.ok) {
            this.setState({
              favMessage: 'favoriteAdded'
            });
            setTimeout(() => this.setState({ favMessage: '' }), 1000);
          }

        });
    }

  }


  onInvitedUserChange(value) {
    let oldEvent = this.state.event;
    let invitedUser = this.state.event.invitedUser;
    let newInvitedUser = {
      ...invitedUser,
      responseType: value
    }
    let newEvent = {
      ...oldEvent,
      invitedUser: newInvitedUser
    }

    this.setState({ event: newEvent });
  }

  onRadioInputChange(value, id) {
    let choiceResponseModels = this.state.event.choiceResponseModels;
    let choice = choiceResponseModels.find(e => e.dateChoiceId === id);
    const index = choiceResponseModels.findIndex(i => i.dateChoiceId === id);
    choice.responseType = value;
    let newModels = [...choiceResponseModels.slice(0, index),
      choice,
    ...choiceResponseModels.slice(index + 1)];

    let oldEvent = this.state.event;
    let newEvent = {
      ...oldEvent,
      choiceResponseModels: newModels
    }
    this.setState({ event: newEvent });
  }

  onSelectTab(name) {
 
    let oldState = this.state;
 
     this.setState({
       ...oldState,
       activeTab: name
     });
   }


  render() {
    const { t } = this.props;
    let user = AuthenticationService.getLoggedUser();


    if (this.state.event.status && !this.state.event.status.ok) {
      return <div><p>{this.state.event.status.message}</p></div>
    }
    let yesCount = 0;
    if (this.state.event && this.state.event.choiceResponseModels) {
      yesCount = this.state.event.choiceResponseModels.filter(e => e.responseType === 'YES').length;
    }

    let declineEnabled = this.state.event && this.state.event.newUserName && this.state.event.newUserEmail;
    let acceptEnabled = declineEnabled && yesCount > 0;

    let lang = i18n.language;
    let countries = getCountries(lang);

    let locationDisplay = getLocationDisplay(this.state.event, countries)



    let isCreator = (this.state.event.invitedUser && this.state.event.invitedUser.invitationStatus === 'CREATOR')
      || (user && user.id === this.state.event.creationUserId);

    let mdValue = this.state.event.imageName ? 6 : 12;
    return (
      <div>
        {(this.state.event.invitedUser) ?
          <Row className="mt-2">
            <Col>
              <Form.Label >{t("duBistEingeladen", { "user": this.state.event.invitedUser.name })}</Form.Label>
            </Col>

          </Row>
          :
          ''
        }
        <Row className="justify-content-md-center" >
          {this.state.event.imageName ?
            <Col className=" mb-2  mt-2 " md={6} xs={12}>
              <Card >
                <Card.Img variant="top" src={this.state.event.imageName ? EVENT_IMG_URL + this.state.event.imageName : "/img/produkt-premium-3.jpg"} className="eImg " />
              </Card>
            </Col>
            : ''
          }

          <Col className=" mb-2  mt-2 " md={mdValue} xs={12}>
            <Card border="light" style={{ "height": "100%" }}>
              <Card.Body>
                <Card.Title className="mb-0">
                  <Row>
                    <Col xs="12" lg={12}>
                      <h2 className="text-success ml-0 mb-0">{this.state.event.title}</h2>

                    </Col>
                  </Row>
                </Card.Title>
                <Row>
                  <Col xs="12" lg="6" md="12">
                    <Form inline className="mb-3">
                      <i className="text-info fa fa-user s16  mr-1 ml-0 " ></i>{this.state.event.username}
                      {isCreator ?
                        <Link to={`/eventChange/${this.props.id}`} className={'form-group float-left '}>
                          <i className=" fa fa-edit s16 ml-5 " ></i>
                          {t("bearbeiten")}</Link>
                        :
                        <OverlayTrigger
                          key="top"
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-top`}>
                              {t( "subscripe")}
                            </Tooltip>
                          } className="float-left" >
                          {user && user.id ?
                            <Button onClick={this.addSubscription} variant="link" className="ml-2 mr-2">{t(this.state.event.subscription ? "subscriped" : "subscripe")}</Button>
                            :
                            <Link to={`/checkLogin/eventEdit/${this.props.id}`} className="ml-2 mr-2" >{t('subscripe')}</Link>
                          }
                        </OverlayTrigger>
                      }
                    </Form>
                  </Col>
                  {!isCreator ?

                    <Col xs="6" lg="3" md="6">
                      <Form inline className="mb-3" >
                        <OverlayTrigger
                          key="top"
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-top`}>
                              {t(this.state.favorite ? "removeFavorite" : "addFavorite")}
                            </Tooltip>
                          } className="float-left" >
                          {user && user.id ?
                            <Button onClick={() => this.addFavorite()} variant="link" className="float-left">
                              {this.state.favorite ?
                                <i class="fas fa-bookmark s16 mr-2  "></i>
                                :
                                <i class="far fa-bookmark s16 mr-2"></i>
                              }

                              {t(this.state.favorite ? "entfernen" : "speichern")}
                            </Button>
                            :
                            <Link to={`/checkLogin/eventEdit/${this.props.id}`} ><i class="far fa-bookmark s16 mr-1 "></i>{t('speichern')}</Link>
                          }
                        </OverlayTrigger>




                      </Form>
                    </Col>

                    : ''
                  }
                  {!isCreator ?
                    <Col lg="3" xs="6" md="6">
                      {user && user.id ?
                        <EventNotify variant={"link"} label={t('notify')}
                          action={this.notifyEvent}
                          title={"notifyPublicEventTitle"} text={"notifyPublicEventComment"} accept={"send"} />
                        :
                        <Link to={`/checkLogin/eventEdit/${this.props.id}`} ><i class="far fa-flag s16 mr-1 "></i>{t('notify')}</Link>
                      }
                    </Col>
                    : ''
                  }

                </Row>

                {this.state.aboMessage ?
                  <Alert variant="info">
                    {t(this.state.aboMessage)}
                  </Alert>
                  :
                  ''
                }
                {this.state.favMessage ?
                  <Alert variant="info">
                    {t(this.state.favMessage)}
                  </Alert>
                  :
                  ''
                }
                <Row>
                  <Col xs="12" lg={12}>
                    <Table borderless={true} className="    mb-2" >
                      <tbody >
                        {this.state.event.description ?
                          <tr >
                            <td colSpan={2} style={{ "padding": "0" }} >
                              <Alert variant="light" >
                                {this.state.event.description}</Alert>
                            </td>
                          </tr>

                          : ''}
                        {this.state.event.eventLink ?
                          <tr >
                            <td style={{ "width": "10px", "padding": "0" }}> <i className="text-info fa fa-globe s16 ml-3  mr-3" ></i></td>
                            <td style={{ "padding": "0" }}><a href={this.state.event.eventLink} role="link" tabindex="1" target="_blank" >{this.state.event.eventLink}</a></td>
                          </tr>
                          : ''}
                        {locationDisplay ?
                          <tr >
                            <td style={{ "width": "10px", "padding": "0" }}> <i className="text-info fa fa-map-marker-alt s16 ml-3  mr-3 " ></i></td>
                            <td style={{ "padding": "0" }}><a href={`${GOOGLEMAP_URL}${encodeURIComponent(locationDisplay)}`} data-href={`${GOOGLEMAP_URL}DATA`} data-action="share/googlemap/share"
                              role="link" tabindex="1" target="_blank" data-channel="map" className="mr-2" >{locationDisplay} </a></td>
                          </tr>
                          : ''}
                        <tr style={{ "height": "3px !important" }}>
                          <td style={{ "padding": "0" }}>&nbsp;</td>
                        </tr>
                      </tbody>
                    </Table>

                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>


        <div>
          {this.state.event.choiceResponseModels ?
            <Card border="light" bg="light" className="mt-3 pt-2" >
              <Card.Title className="text-success mb-2">
                <i className=" fa fa-users  ml-3 mr-3" ></i>
                <span className="addTitle text-dark" >{t("MoechtenSieteilnehmen")}</span>
              </Card.Title>

              <Card.Body >
                <Form.Label className="ml-4">{t("SelektierenPassendTer1")}</Form.Label>
                {this.state.event.choiceResponseModels.map((termin, i) =>
                  <div key={i} className="ml-3 ">
                    {i > 0 ? <hr className="mt-3 mb-3" style={{ "border": "1px solid #DDDDDD", "border-radius": "1px" }} /> : ''}
                    <Row className={termin.ultimate ? "greenBg " : ""}>
                      <Col lg={8} md={12}>
                        <DateChoice item={termin} isCreator={isCreator} onClickHandler={this.onRadioInputChange} />
                      </Col>
                      <Col lg={4} md={12}>
                        {termin.counter != null ?
                          (<div className="mt-2">
                            <ProgressBar >
                              {termin.counter.yesCount > 0 ?
                                <ProgressBar style={{ "background": termin.ultimate ? GREEN : GREEN_LIGHT, "color": "black" }} now={(termin.counter.yesCount * 100) / (termin.counter.yesCount + termin.counter.noCount)} key={1}
                                  label={t("yesLabel", { "count": termin.counter.yesCount })} />
                                : ''}
                              {termin.counter.noCount > 0 ?
                                <ProgressBar style={{ "background": RED_LIGHT, "color": "black" }} now={(termin.counter.noCount * 100) / (termin.counter.yesCount + termin.counter.noCount)} key={2}
                                  label={t("noLabel", { "count": termin.counter.noCount })} />
                                : ''}
                            </ProgressBar>


                          </div>) : ''}
                      </Col>

                    </Row>
                    <Row>
                      <Col>
                        {termin.counter.yesCount > 0 ?
                          <DateChoiceResponseInfo id={termin.dateChoiceId} max={termin.counter.yesCount} type={'YES'} />
                          : ''}

                      </Col>
                      <Col>
                        {termin.counter.noCount > 0 ?
                          <DateChoiceResponseInfo id={termin.dateChoiceId} max={termin.counter.noCount} type={'NO'} />
                          : ''}
                      </Col>

                    </Row>
                    {isCreator ?
                      <Row className={"mb-3 "}  >
                        <Col lg={4} md={2}>&nbsp;</Col>
                        <Col lg={8} md={10}>
                          <Button variant="link" onClick={() => this.ultimateChange(termin)} className="float-right mt-2 " size="sm"><span className={termin.ultimate ? "fa fa-trash " : "fa fa-crown "} ></span>{" " + t(termin.ultimate ? "ultimateReset" : "ultimateSet")}</Button>
                        </Col>
                      </Row>
                      :
                      ""
                    }
                  </div>
                )}


                <Row style={{ "backgroundColor": GREEN_LIGHT }} className="pb-3 mt-3 pt-2">
                  <Col lg="12" xs="12">
                    <Form.Label >{t("SelektierenPassendTer2")}</Form.Label>
                  </Col>
                  <Col lg="4" xs="12" className="mt-1">
                    <Form.Control placeholder="Name" onChange={this.onInputChange}
                      name="newUserName" value={this.state.event.newUserName} />
                  </Col>
                  <Col lg="4" xs="12" className="mt-1">
                    <Form.Control placeholder="E-Mail" type="email" onChange={this.onInputChange}
                      name="newUserEmail" value={this.state.event.newUserEmail} />
                  </Col>
                  <Col lg="4" xs="12" className="mt-1">
                    <Button variant="success" onClick={() => this.saveEvent()} className={'float-left ml-1 '} disabled={!acceptEnabled} >{(yesCount > 0 ? yesCount + " " : "") + t(yesCount > 1 ? "sendParticipations" : "sendParticipation")}</Button>
                    <Button variant="warning" onClick={() => this.sendDecline()} className={'float-right ml-2'} disabled={!declineEnabled} >{t("declineParticipation")}</Button>
                  </Col>
                </Row>



              </Card.Body>
            </Card>
            :
            ""
          }
          {!declineEnabled || !acceptEnabled ?
            <Row className="justify-content-md-left mt-3" >
              <Col lg={8} md={12}>
                <Toast style={{ "backgroundColor": LIGHT_BORDER }}>
                  <Toast.Body>
                    <ul>
                      {!declineEnabled ?
                        <li>{t("requiredUsername")}</li>
                        :
                        ''
                      }
                      {yesCount < 1 ?
                        <li>{t("requiredChoiceDate")}</li>
                        :
                        ''
                      }
                    </ul>


                  </Toast.Body>
                </Toast>
              </Col>
            </Row>
            : ''
          }



          {this.state.message ?
            <Row className="mt-2">
              <Col>
                <Alert variant="success">
                  {t(this.state.message)}
                </Alert>

              </Col>
            </Row>
            :
            ""
          }
        </div>


        {this.state.event.invitedUser && this.state.event.invitedUser.id && this.state.event.userCommentsEnabled === true ?
         
          <Tabs defaultActiveKey={this.state.activeTab} id="noanim-tab-event" onSelect={(e) => this.onSelectTab(e)} className={"ml-2 mr-2"}>
            <Tab eventKey="comments" title={t("comments")} className=" pt-2 pl-2  pb-1 "    onSelect={() => this.onSelectTab('comments')}>
                <CommentList invitedUser={this.state.event.invitedUser} activePage={this.state.activePage} />
            </Tab>
            <Tab eventKey="polls" title={t("polls")} className=" pt-2 pl-2  pb-1 "    onSelect={() => this.onSelectTab('polls')}>
                <CommentList invitedUser={this.state.event.invitedUser} activePage={this.state.activePage} />
            </Tab>

          </Tabs>
          :
          ""
        }

        <Row className="mt-5">
          <Col lg={8} xs={12} md="auto" md={{ span: 3, offset: 3 }}>
            <Sharing url={EDIT_URL + this.state.event.urlParam} title={t("eventPartLink")} />
          </Col>
        </Row>



      </div>);
  }
}

export default translate("translations")(EventEditPages);
